import React, { useContext } from 'react';
import { FiArrowRight, FiBookOpen, FiCheckCircle, FiLayers } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../Context';
import NavbarGlobal from './NavbarGlobal';
import './MaterialBiblioteca.scss';

const contenidoPorNivel = {
    1: 'Fundamentos y conceptos esenciales para comenzar tu proceso.',
    2: 'Estrategias para fortalecer la comprensión y la fluidez lectora.',
    3: 'Recursos avanzados para profundizar y aplicar lo aprendido.',
};

const MaterialTeorico = () => {
    const { teacher, level, currentUser } = useContext(AppContext);
    const navigate = useNavigate();

    const userLevel = Number.parseInt(level, 10);
    const tieneAccesoTotal = teacher || currentUser?.isMaster;
    const nivelesVisibles = tieneAccesoTotal
        ? [1, 2, 3]
        : Array.from({ length: Number.isFinite(userLevel) ? Math.min(userLevel, 3) : 0 }, (_, i) => i + 1);

    const handleVerDetalle = (nivel) => {
        navigate(`/dashboard/material-teorico/detalle/${nivel}`);
    };

    return (
        <div className="material-library">
            <NavbarGlobal title="Material teórico" showBackButton={true} />
            <main className="material-library__container">
                <section className="material-library__hero" aria-labelledby="material-teorico-title">
                    <div className="material-library__hero-copy">
                        <span className="material-library__eyebrow">
                            <FiBookOpen aria-hidden="true" /> Biblioteca de aprendizaje
                        </span>
                        <h1 id="material-teorico-title">Aprende a tu ritmo, nivel por nivel</h1>
                        <p>
                            Consulta explicaciones y recursos que acompañan tu proceso de lectura.
                            {tieneAccesoTotal
                                ? ' Tienes acceso a todos los niveles.'
                                : ' Los niveles disponibles corresponden a tu progreso actual.'}
                        </p>
                    </div>
                    <div className="material-library__hero-mark" aria-hidden="true">
                        <FiLayers />
                        <strong>{nivelesVisibles.length}</strong>
                        <span>{nivelesVisibles.length === 1 ? 'nivel disponible' : 'niveles disponibles'}</span>
                    </div>
                </section>

                {nivelesVisibles.length > 0 ? (
                    <section className="material-library__section" aria-labelledby="niveles-title">
                        <div className="material-library__section-heading">
                            <div>
                                <span className="material-library__section-kicker">Tu recorrido</span>
                                <h2 id="niveles-title">Elige un nivel para comenzar</h2>
                            </div>
                            <span className="material-library__access-note">
                                <FiCheckCircle aria-hidden="true" /> Contenido habilitado
                            </span>
                        </div>

                        <div className="material-level-grid">
                            {nivelesVisibles.map((nivel) => (
                                <button
                                    key={nivel}
                                    type="button"
                                    className="material-level-card"
                                    onClick={() => handleVerDetalle(nivel)}
                                    aria-label={`Ver material teórico del nivel ${nivel}`}
                                >
                                    <span className="material-level-card__tab">Nivel {nivel}</span>
                                    <span className="material-level-card__icon" aria-hidden="true">
                                        <FiBookOpen />
                                    </span>
                                    <span className="material-level-card__body">
                                        <strong>Material del nivel {nivel}</strong>
                                        <span>{contenidoPorNivel[nivel]}</span>
                                    </span>
                                    <span className="material-level-card__action">
                                        Explorar contenido <FiArrowRight aria-hidden="true" />
                                    </span>
                                </button>
                            ))}
                        </div>
                    </section>
                ) : (
                    <section className="material-library__empty" role="status">
                        <span className="material-library__empty-icon"><FiBookOpen aria-hidden="true" /></span>
                        <h2>Tu material estará disponible pronto</h2>
                        <p>Aún no tienes un nivel asignado. Contacta a tu profesor para comenzar.</p>
                    </section>
                )}
            </main>
        </div>
    );
};

export { MaterialTeorico };
